var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeedback(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 84,
    viewBox: "0 0 114 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5417_9420)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 114,
    height: 84,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5417_9420",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 114,
    height: 84
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M114 0H0V84H114V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5417_9420)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_5417_9420",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -12,
    width: 114,
    height: 116
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 -11.0583H114V103.777H0V-11.0583Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_5417_9420)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0266 78.715C3.53841 67.6832 10.8641 56.9975 13.3167 49.9635C16.3251 41.3355 5.32367 28.4613 17.0266 22.6282C30.7611 15.7824 46.9111 12.6341 69.2528 23.604C91.5944 34.574 102.585 38.9866 104.634 55.1264C106.683 71.2661 95.327 78.715 95.327 78.715H17.0266Z",
    fill: "url(#paint0_linear_5417_9420)"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0849 79.4464H100.927C101.351 79.4464 101.695 79.0999 101.695 78.6724V78.5086C101.695 78.0811 101.351 77.7346 100.927 77.7346H14.0849C13.6605 77.7346 13.3164 78.0811 13.3164 78.5086V78.6724C13.3164 79.0999 13.6605 79.4464 14.0849 79.4464Z",
    fill: "#FEE2BF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3284 13.2722H24.3372C22.1166 13.2722 20.3164 14.9468 20.3164 17.0126V50.4897C20.3164 52.5555 22.1166 54.2302 24.3372 54.2302H29.7297L29.0005 64.2195L38.6887 54.2302H76.3284C78.5491 54.2302 80.3493 52.5555 80.3493 50.4897V17.0126C80.3493 14.9468 78.5491 13.2722 76.3284 13.2722Z",
    fill: "#6750A4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7035 36.7605H29.0484C28.4758 36.7605 28.0117 36.2929 28.0117 35.7161C28.0117 35.1394 28.4758 34.6719 29.0484 34.6719H37.7035C38.276 34.6719 38.7402 35.1394 38.7402 35.7161C38.7402 36.2929 38.276 36.7605 37.7035 36.7605Z",
    fill: "#F3FFFF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M72.4035 36.7605H43.8257C43.2532 36.7605 42.7891 36.293 42.7891 35.7162C42.7891 35.1395 43.2532 34.6719 43.8257 34.6719H72.4035C72.9759 34.6719 73.4401 35.1394 73.4401 35.7161C73.4401 36.2929 72.9759 36.7605 72.4035 36.7605Z",
    fill: "#F3FFFF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4433 42.2717H29.0484C28.4758 42.2717 28.0117 41.8042 28.0117 41.2275C28.0117 40.6507 28.4758 40.1831 29.0484 40.1831H50.4433C51.016 40.1831 51.4801 40.6507 51.4801 41.2275C51.4801 41.8042 51.0159 42.2717 50.4433 42.2717Z",
    fill: "#F3FFFF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M72.4036 31.2492H29.0483C28.4757 31.2492 28.0117 30.7816 28.0117 30.2049C28.0117 29.6282 28.4758 29.1606 29.0484 29.1606H72.4036C72.9761 29.1606 73.4402 29.6282 73.4402 30.2049C73.4402 30.7816 72.9761 31.2492 72.4036 31.2492Z",
    fill: "#F3FFFF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M72.4048 42.2717H55.9508C55.3782 42.2717 54.9141 41.8042 54.9141 41.2275C54.9141 40.6507 55.3782 40.1831 55.9508 40.1831H72.4047C72.9773 40.1831 73.4414 40.6506 73.4414 41.2274C73.4414 41.8041 72.9773 42.2717 72.4048 42.2717Z",
    fill: "#F3FFFF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M72.4034 47.7831H29.0484C28.4758 47.7831 28.0117 47.3154 28.0117 46.7387C28.0117 46.162 28.4758 45.6943 29.0484 45.6943H72.4036C72.9761 45.6943 73.4402 46.1619 73.4402 46.7386V46.7387C73.4402 47.3154 72.976 47.7831 72.4034 47.7831Z",
    fill: "#F3FFFF"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5384 17.6855L70.744 20.1463L73.4399 20.541L71.4891 22.4564L71.9496 25.1612L69.5384 23.8842L67.1271 25.1612L67.5876 22.4564L65.6367 20.541L68.3327 20.1463L69.5384 17.6855Z",
    fill: "#2BA14C"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9133 17.6855L33.1189 20.1463L35.8148 20.541L33.864 22.4564L34.3245 25.1612L31.9133 23.8842L29.5018 25.1612L29.9625 22.4564L28.0117 20.541L30.7076 20.1463L31.9133 17.6855Z",
    fill: "#FCC13F"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5533 21.4148C31.9594 21.4148 30.5619 22.2691 29.7738 23.553L29.5 25.1612L31.9113 23.8842L34.3225 25.1612L33.8621 22.4564L34.752 21.5826C34.3704 21.4741 33.9688 21.4148 33.5533 21.4148Z",
    fill: "#5C5C5C"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3196 17.6855L42.5252 20.1463L45.2212 20.541L43.2704 22.4564L43.7308 25.1612L41.3196 23.8842L38.9083 25.1612L39.3688 22.4564L37.418 20.541L40.1139 20.1463L41.3196 17.6855Z",
    fill: "#FCC13F"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9635 21.4148C41.3697 21.4148 39.972 22.2691 39.184 23.553L38.9102 25.1612L41.3215 23.8842L43.7327 25.1612L43.2722 22.4564L44.1621 21.5826C43.7805 21.4741 43.379 21.4148 42.9635 21.4148Z",
    fill: "#5C5C5C"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7258 17.6855L51.9314 20.1463L54.6273 20.541L52.6765 22.4564L53.1371 25.1612L50.7258 23.8842L48.3145 25.1612L48.775 22.4564L46.8242 20.541L49.5202 20.1463L50.7258 17.6855Z",
    fill: "#FCC13F"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3697 21.4148C50.7759 21.4148 49.3783 22.2691 48.5902 23.553L48.3164 25.1612L50.7277 23.8842L53.139 25.1612L52.6785 22.4564L53.5685 21.5826C53.187 21.4741 52.7852 21.4148 52.3697 21.4148Z",
    fill: "#5C5C5C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M60.132 17.6855L61.3377 20.1463L64.0336 20.541L62.0828 22.4564L62.5433 25.1612L60.132 23.8842L57.7207 25.1612L58.1812 22.4564L56.2305 20.541L58.9264 20.1463L60.132 17.6855Z",
    fill: "#2BA14C"
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M88.5249 75.8966C88.5249 75.8966 88.8616 76.8675 88.8619 76.8699C88.8869 77.0237 88.9854 77.4038 88.9854 77.5436C88.9854 78.0689 86.6654 77.0978 87.1853 76.8649C87.2323 76.844 87.3801 76.6755 87.3955 76.4967C87.4192 76.2213 87.2001 75.8757 87.2001 75.8757L88.5249 75.8966Z",
    fill: "#F7A491"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M84.6518 57.5396C84.6518 57.5396 84.4771 59.146 84.4771 59.1718C84.4771 61.9873 84.1509 67.4866 84.2548 68.0159C84.5083 69.307 87.2777 76.3336 87.2777 76.3336L88.7128 76.1271L86.7906 67.8275L87.4979 64.6537L88.4988 58.3801L84.6518 57.5396Z",
    fill: "#2D2861"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1185 77.7169L88.8529 76.8599C88.8529 76.8599 88.2948 77.1008 88.0158 77.0607C87.7368 77.0205 87.1922 76.8599 87.1922 76.8599C86.0786 77.2341 85.1661 77.4159 85.3321 77.7169H89.1185Z",
    fill: "#2D2861"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M93.5555 74.9763C93.5555 74.9763 93.9315 75.3512 93.9401 75.4886C93.9486 75.6261 93.9734 77.0994 93.82 77.2369C93.6666 77.3744 93.2153 77.4719 93.3604 77.6266C93.47 77.7435 94.3131 77.7186 94.8718 77.6872C95.0349 77.6779 95.2395 76.3491 95.3041 76.1539C95.3978 75.8702 95.7359 75.2529 95.6507 75.0552C95.6091 74.9589 95.3005 74.7393 95.0202 74.5545C94.7255 74.3601 94.4435 73.9275 94.4435 73.9275L93.5555 74.9763Z",
    fill: "#F7A491"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M90.0595 58.945L90.3393 60.5946L91.0966 67.3834L94.8031 74.2726C94.8031 74.2726 94.2459 75.1347 93.6474 75.2702L88.3863 68.3074L85.5352 59.5906L85.6351 57.6541L90.0595 58.945Z",
    fill: "#352E73"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M95.0007 74.5452C95.0007 74.5452 94.1338 77.0372 93.7945 77.1576C93.7045 77.1894 93.2722 77.2704 93.1907 77.4656C93.166 77.5244 93.1907 77.7209 93.1907 77.7209H94.9975C94.9975 77.7209 95.2259 76.6228 95.3162 76.1405C95.3162 76.1405 95.7945 74.9617 95.7415 74.8546C95.6882 74.7474 95.0007 74.5452 95.0007 74.5452Z",
    fill: "#2D2861"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M83.1526 40.2981C83.1198 40.392 82.9693 40.651 82.9693 40.651C82.9693 40.651 83.9805 45.0548 84.0509 45.3293L85.3901 47.2368L84.0403 48.3981C84.0403 48.3981 82.5445 46.1914 82.5162 46.0804C82.4879 45.9693 82.1007 42.6209 82.1007 42.6209C82.1007 42.6209 81.9747 40.8734 81.9631 40.787C81.9515 40.7007 81.623 40.1768 81.5428 39.9588C81.4685 39.7573 81.3696 39.1169 81.3696 39.1169L81.4548 38.9496L81.931 38.7746L82.2833 38.7669C82.2833 38.7669 83.1281 38.9827 83.1732 39.0813C83.1936 39.126 83.2353 39.7505 83.2168 39.9729C83.2098 40.0554 83.1801 40.2198 83.1526 40.2981Z",
    fill: "#F7A491"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M83.4996 28.8465L83.7942 32.8648L87.2534 34.8922L83.5435 36.4232L82.6884 40.3619L80.1011 37.2899L76.1134 37.6966L78.2242 34.267L76.6148 30.5798L80.5067 31.5322L83.4996 28.8465Z",
    fill: "#FCC13F"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M83.7004 34.8365C81.5281 33.956 79.1549 34.3471 77.3772 35.6597L76.1226 37.6981L80.109 37.2915L82.6955 40.3623L83.5503 36.4253L85.2423 35.7271C84.7816 35.3686 84.2666 35.066 83.7004 34.8365Z",
    fill: "#5C5C5C"
  }))), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M82.8866 39.4935C82.8679 39.397 82.8562 39.1909 82.8562 39.1909C82.8562 39.1909 82.5968 38.8153 82.6399 38.7819C82.7908 38.6649 83.1718 39.0758 83.1718 39.0758C83.1718 39.0758 82.9472 39.8065 82.8866 39.4935Z",
    fill: "#F7A491"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M81.5507 39.9451C81.5507 39.9451 81.2168 39.1385 81.2808 38.8896C81.3219 38.7299 82.1015 38.2904 82.2267 38.4219C82.3409 38.542 81.5876 38.9265 81.6156 38.9553C81.6623 39.0029 82.1691 38.5448 82.2812 38.6038C82.4069 38.6699 81.8072 39.1588 81.8457 39.2178C81.8701 39.2552 82.1842 38.8231 82.245 38.9873C82.306 39.1514 81.5507 39.9451 81.5507 39.9451Z",
    fill: "#F7A491"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M84.9939 50.6457C84.7801 50.0532 83.3944 48.1133 83.3944 48.1133C83.3944 48.1133 84.4827 46.6964 85.322 46.6323C85.322 46.6323 86.1617 48.0525 87.0479 48.5029C87.2314 48.5961 85.0945 50.924 84.9939 50.6457Z",
    fill: "#FC008B"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M84.5109 56.5696L84.7988 52.5556C84.8916 51.5645 84.9273 50.7732 84.8472 50.4879C84.6771 49.8803 85.432 48.0821 86.4679 48.2974C86.8497 48.3768 87.1627 48.4251 87.5074 48.4745C88.6158 48.6329 88.3774 48.6402 88.8287 48.6878C89.3575 48.7434 89.8589 48.828 90.2656 48.9984C91.1124 49.353 90.4776 52.5459 90.3815 53.0653C90.2359 53.8504 90.5148 60.4626 90.5148 60.4626C90.5148 60.4626 88.0862 61.0154 84.3603 59.1819L84.5109 56.5696Z",
    fill: "#FC008B"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M88.6003 46.933L88.8649 48.7213C88.8649 48.7213 87.8927 50.8057 87.3083 50.6237C86.8179 50.471 87.1241 48.5633 87.1241 48.5633C87.1241 48.5633 87.3845 47.6082 87.3039 47.1078C87.2234 46.6075 88.6003 46.933 88.6003 46.933Z",
    fill: "#F7A491"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M88.4123 47.4738C88.1612 47.6015 87.6648 47.7761 87.2781 47.8185C87.3149 47.5682 87.3358 47.3034 87.3043 47.1078C87.2671 46.8769 87.5405 46.8221 87.8456 46.8299C88.2447 46.8662 88.6007 46.933 88.6007 46.933L88.6516 47.2767C88.5757 47.3628 88.4961 47.4313 88.4123 47.4738Z",
    fill: "#FE875E"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M89.8646 44.8689C89.9059 44.8691 89.47 46.8674 88.7931 47.2116C88.1162 47.5559 87.106 47.3776 86.9161 46.8396C86.706 46.2446 87.469 44.2055 88.4213 43.9459C89.3735 43.6862 89.8646 44.8689 89.8646 44.8689Z",
    fill: "#F7A491"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M89.0819 43.034C89.623 43.3689 89.8716 43.8661 89.9553 44.0698C90.2093 44.1992 90.5168 44.479 90.6648 45.2336C90.8468 46.1616 90.2028 46.8775 89.5197 47.0933C88.8365 47.3091 88.7214 47.7954 88.7214 47.7954L88.6533 47.2722C88.6533 47.2722 88.8049 46.8166 89.0333 46.5883C89.2618 46.3602 88.9246 46.0282 88.8948 45.7571C88.8718 45.5486 89.0144 45.1432 88.9832 44.8009L88.9001 44.5177C88.9001 44.5177 88.6288 44.0833 88.2284 44.0299C87.828 43.9764 88.3875 42.6043 89.0819 43.034Z",
    fill: "#2D2861"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M95.065 51.35L94.4119 55.3418L97.306 58.1467L93.3354 58.7545L91.5814 62.3938L89.7807 58.7777L85.8024 58.222L88.6602 55.3794L87.9555 51.3966L91.5225 53.2559L95.065 51.35Z",
    fill: "#FCC13F"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M93.8536 57.2394C91.9437 55.8606 89.5407 55.6753 87.5018 56.5319L85.8026 58.2221L89.7808 58.7778L91.5815 62.3939L93.3355 58.7545L95.1469 58.4773C94.7823 58.0172 94.3515 57.5987 93.8536 57.2394Z",
    fill: "#5C5C5C"
  }))), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M92.6234 52.2969C92.6234 52.2969 93.4919 53.4796 93.5454 53.688C93.5988 53.8963 93.2226 58.8121 93.2028 59.2458C93.2028 59.2458 93.3634 59.7701 93.4537 60.103C93.5441 60.4357 93.5843 60.6828 93.5393 60.7483C93.4944 60.8139 93.3542 60.7687 93.2992 60.8948C93.2442 61.021 93.084 61.0008 93.034 61.0261C92.984 61.0513 92.8366 61.238 92.7814 61.233C92.7264 61.2281 92.6363 61.2181 92.5887 61.2484C92.5411 61.2787 92.4613 61.362 92.3485 61.3419C92.236 61.3217 92.1801 61.2571 92.1801 61.2571C92.1801 61.2571 92.2678 60.3534 92.2027 60.356C92.1377 60.3586 91.9725 60.4344 91.95 60.49C91.9276 60.5454 91.9376 60.669 91.9151 60.7244C91.8926 60.78 91.8176 60.833 91.7501 60.8103C91.6825 60.7876 91.6923 60.4775 91.6923 60.4775C91.6923 60.4775 91.7022 60.2254 91.7921 60.0766C92.1038 59.5609 92.1717 59.6329 92.212 59.5668C92.232 59.534 92.206 58.2607 92.206 58.2607C92.206 58.2607 92.078 54.6441 92.0645 54.4491L91.1491 53.0847L92.6234 52.2969Z",
    fill: "#F8A492"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M92.9832 52.3099L91.1557 53.6968C91.1557 53.6968 90.1558 52.1801 89.6194 51.6403C88.9473 50.9641 89.8894 48.8145 90.2946 49.0073C91.2912 49.4818 92.9832 52.3099 92.9832 52.3099Z",
    fill: "#FC008B"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5417_9420",
    x1: 57.529,
    y1: 14.9922,
    x2: 56.7815,
    y2: 74.3581,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BF9FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#C3FBF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#FAFEE5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5417_9420"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 114,
    height: 84,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedback);
export default __webpack_public_path__ + "static/media/feedback.bf35cb47e85210dd20e82a1bf597f7fa.svg";
export { ForwardRef as ReactComponent };